import { message } from "antd";

export const copyToClipboard = async (textToCopy) => {
  const { alarmId, accountId, loggerId, meterId, ...newJSON } = textToCopy;

  const formattedOutput = Object.entries(newJSON)
    ?.map(([key, value]) => `${key}: ${value}`)
    ?.join("\n");
  try {
    await navigator.clipboard.writeText(formattedOutput);
    message.success("Text copied to clipboard");
  } catch (err) {
    message.error("Unable to copy text to clipboard.");
  }
};
